module.exports = __webpack_public_path__ + "static/media/KinjaRun@768.4b99e97f.png";